module.exports = __webpack_public_path__ + "static/media/4en.f9e7617b.jpg";